const processImage =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597849/oak-and-stone-remodel/process/process-consultation.webp';
const aboutImage =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597760/oak-and-stone-remodel/about/team.webp';
const careersImage =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597851/oak-and-stone-remodel/process/process-manufacturing.webp';
const featuredImage =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597871/oak-and-stone-remodel/kitchen/kitchen1.webp';

export const companyData = [
  {
    title: 'Process',
    text: 'From Concept to Creation: Our Step-by-Step Process',
    slug: 'process',
    image: processImage
  },
  {
    title: 'About',
    text: 'Discover what sets us apart—our commitment to quality craftsmanship, exceptional customer service, and designs tailored to your unique vision.',
    slug: 'about',
    image: aboutImage
  },
  {
    title: 'Featured Services',
    text: 'Explore our most popular remodeling services, including kitchens, bathrooms, custom cabinets, and more.',
    slug: 'featured',
    image: featuredImage
  },
  {
    title: 'Careers',
    text: 'Join our team and build your career with a company that values innovation, craftsmanship, and a passion for excellence. Explore current opportunities today!',
    slug: 'careers',
    image: careersImage
  }
];
